/* ErgoLab PDP scripts (Shopify port) */
(function ($) {
  'use strict';
  var swipers = {};

  function destroy(key) { if (swipers[key]) { try { swipers[key].destroy(true, true); } catch (e) {} delete swipers[key]; } }

  function initHero() {
    if (!$('.mainSwiper').length || typeof Swiper === 'undefined') return;
    destroy('thumb'); destroy('main'); destroy('trev');
    swipers.thumb = new Swiper('.thumbSwiper', { spaceBetween: 8, slidesPerView: 5, freeMode: true, watchSlidesProgress: true, slideToClickedSlide: true, breakpoints: { 0: { spaceBetween: 4 }, 768: { spaceBetween: 8 } } });
    swipers.main = new Swiper('.mainSwiper', { spaceBetween: 10, loop: true, speed: 600, thumbs: { swiper: swipers.thumb }, navigation: { nextEl: '.mainSwiper .swiper-button-next', prevEl: '.mainSwiper .swiper-button-prev' } });
    swipers.thumb.on('click', function (sw) {
      var i = sw.clickedIndex; if (i === undefined) return;
      swipers.main.slideToLoop(i);
      var last = sw.activeIndex + sw.params.slidesPerView - 1;
      if (i >= last) sw.slideNext(); else if (i <= sw.activeIndex) sw.slidePrev();
    });
    if ($('.feature_tab-panel-review .swiper-slide').length) {
      swipers.trev = new Swiper('.feature_tab-panel-review', { slidesPerView: 1.4, spaceBetween: 15, loop: true });
    }
  }

  function initSteps() {
    if (!$('.steps_block').length || typeof Swiper === 'undefined') return;
    destroy('stepthumb'); destroy('steps');
    swipers.stepthumb = new Swiper('.step_thumb', { spaceBetween: 5, slidesPerView: 3, slideToClickedSlide: true, watchSlidesProgress: true, breakpoints: { 0: { slidesPerView: 3, spaceBetween: 5 }, 768: { slidesPerView: 3, spaceBetween: 8 } } });
    swipers.steps = new Swiper('.steps_block', { slidesPerView: 1.2, spaceBetween: 15, loop: true, thumbs: { swiper: swipers.stepthumb }, breakpoints: { 768: { slidesPerView: 3, spaceBetween: 24, allowTouchMove: false } } });
  }

  function initShop() {
    if (!$('.index_shop').length || typeof Swiper === 'undefined') return;
    destroy('shop');
    swipers.shop = new Swiper('.index_shop', { slidesPerView: 1.2, spaceBetween: 14, loop: $('.index_shop .swiper-slide').length > 3, navigation: { nextEl: '.index_shop .swiper-button-next', prevEl: '.index_shop .swiper-button-prev' }, pagination: { el: '.index_shop .swiper-pagination', clickable: true }, breakpoints: { 768: { slidesPerView: 3, spaceBetween: 24 } } });
  }

  function initTabs() {
    $(document).off('click.pdptab').on('click.pdptab', '.feature_tab-col', function () {
      var card = $(this).closest('.feature_card');
      card.find('.feature_tab-col').removeClass('active').attr('aria-selected', 'false');
      card.find('.feature_tab-panel').prop('hidden', true);
      $(this).addClass('active').attr('aria-selected', 'true');
      $('#' + $(this).attr('aria-controls')).prop('hidden', false);
      if (swipers.trev) swipers.trev.update();
    });
  }

  // "What you will receive" labels follow the selected bundle: a label with data-per="2"
  // (pillowcases) shows 2 x pillows, data-per="1" shows the pillow count, etc.
  function updateIncluded(q) {
    document.querySelectorAll('.included_col p[data-per]').forEach(function (p) {
      var per = parseFloat(p.getAttribute('data-per')); if (!per) return;
      p.textContent = (p.getAttribute('data-base') || '').replace(/\d+/, String(Math.round(per * q)));
    });
  }
  function initBundles() {
    $(document).off('click.pdpqs').on('click.pdpqs', '.qs-card', function () {
      $('.qs-card').removeClass('sel'); $(this).addClass('sel');
      var q = parseInt($(this).data('qty'), 10);
      if (q > 0) { $('#pdp-qty').val(q); updateIncluded(q); }
    });
    var sel = $('.qs-card.sel').first();
    if (sel.length && parseInt(sel.data('qty'), 10) > 0) { var q0 = parseInt(sel.data('qty'), 10); $('#pdp-qty').val(q0); updateIncluded(q0); }
  }

  function initAtc() {
    $(document).off('submit.pdpatc').on('submit.pdpatc', '#pdp-atc-form', function (e) {
      e.preventDefault();
      var form = this, $btn = $('#pdp-atc'), $msg = $('#pdp-atc-msg'), after = $(form).data('after') || 'cart';
      $btn.prop('disabled', true); $msg.prop('hidden', true).text('');
      var fd = new FormData(form);
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.j.description || res.j.message || 'Could not add to cart'); }
          if (after === 'checkout') { window.location.href = '/checkout'; }
          else if (after === 'stay') {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { $('#pdp-cart-count').text(c.item_count); });
            $btn.prop('disabled', false);
            $msg.text('Added to cart').css('color', '#1a8f3c').prop('hidden', false);
          } else if (typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function') {
            // UpCart is installed: open its cart drawer instead of leaving for /cart.
            $btn.prop('disabled', false);
            try { window.upcartRefreshCart(); window.upcartOpenCart(); }
            catch (e2) { window.location.href = '/cart'; }
          } else { window.location.href = '/cart'; }
        })
        .catch(function (err) { $btn.prop('disabled', false); $msg.text(err.message).css('color', '#c00').prop('hidden', false); });
    });
  }

  function initAccordions() {
    // buy box question rows
    $(document).off('click.pdpq').on('click.pdpq', '.hero_question_heading', function () {
      var q = $(this), a = q.next('.hero_question_content'), hh = $(window).width() <= 767 ? 50 : 80;
      $('.hero_question_content').not(a).filter(':visible').each(function () { var d = $(this); d.stop(true, true).slideUp(400, function () { d.prev('.hero_question_heading').removeClass('hero_question_heading_open'); }); });
      if (a.is(':visible')) { a.stop(true, true).slideUp(400, function () { q.removeClass('hero_question_heading_open'); }); }
      else { q.addClass('hero_question_heading_open'); a.stop(true, true).slideDown(400, function () { $('html, body').animate({ scrollTop: q.offset().top - hh }, 300); }); }
    });
    // technology layers
    $(document).off('click.pdptech').on('click.pdptech', '.technology_tab-accodian-heading', function () {
      var c = $(this).next('.technology_tab-accodian-content');
      if (c.is(':visible')) { c.slideUp(500); $(this).removeClass('active'); }
      else { $('.technology_tab-accodian-content').slideUp(); c.slideDown(500); $('.technology_tab-accodian-heading').removeClass('active'); $(this).addClass('active'); }
    });
    // FAQ accordions
    $(document).off('click.pdpfaq').on('click.pdpfaq', '.acdn-heading', function () {
      var q = $(this), a = q.next('.acdn-content'), box = q.closest('.faq-container');
      box.find('.acdn-content').not(a).filter(':visible').each(function () { var d = $(this); d.slideUp(400, function () { d.prev('.acdn-heading').removeClass('accordion-open'); }); });
      if (a.is(':visible')) { a.stop().slideUp(400, function () { q.removeClass('accordion-open'); }); }
      else { q.addClass('accordion-open'); a.stop().slideDown(400); }
    });
    // FAQ tabs
    $(document).off('click.pdpfaqtab').on('click.pdpfaqtab', 'ul.faq_tab_list li', function (e) {
      e.preventDefault();
      var id = $(this).data('id'), tabs = $('ul.faq_tab_list li'), items = $('.faq-container');
      tabs.removeClass('active'); items.removeClass('active'); $(this).addClass('active');
      var show = id === 'faq_tab_all' ? items : items.filter('[data-id="' + id + '"]');
      show.addClass('active');
      show.each(function () {
        $(this).find('.acdn-content').stop(true, true).slideUp(0);
        $(this).find('.acdn-heading').removeClass('accordion-open');
      });
      var first = show.first();
      first.find('.acdn-heading').first().addClass('accordion-open');
      first.find('.acdn-content').first().stop(true, true).slideDown(300);
    });
    // load more reviews
    $(document).off('click.pdpmore').on('click.pdpmore', '.load-more > a', function (e) {
      e.preventDefault();
      $('.product-detail_review_box.hide-review').slice(0, 8).removeClass('hide-review');
      if (!$('.product-detail_review_box.hide-review').length) $('.load-more').remove();
    });
    // footer accordions (mobile)
    $(document).off('click.pdpfoot').on('click.pdpfoot', '.footer-links .accordion-toggle', function () {
      if ($(window).innerWidth() > 767) return;
      $(this).next('.footer-links-list').slideToggle(); $(this).toggleClass('active');
    });
    // smooth scroll to buy box / reviews
    $(document).off('click.pdpscroll').on('click.pdpscroll', '.btn_scroll', function (e) {
      e.preventDefault(); var t = $('#getOrder'); if (!t.length) return;
      $('html, body').animate({ scrollTop: t.offset().top - ($(window).width() <= 767 ? 60 : 70) }, 900);
    });
    $(document).off('click.pdprev').on('click.pdprev', '.pop-all_review', function () {
      var t = $('#reviews'); if (!t.length) return;
      $('html, body').animate({ scrollTop: t.offset().top - ($(window).width() <= 767 ? 50 : 70) }, 900);
    });
  }

  function initTemperatureBars() {
    var sec = document.querySelector('.bacteria_box-result'); if (!sec || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      sec.querySelectorAll('.bacteria_box-result-col').forEach(function (row, ri) {
        row.querySelectorAll('.bacteria-progress span.active').forEach(function (bar, i) { setTimeout(function () { bar.classList.add('show'); }, ri * 600 + i * 100); });
      });
      obs.unobserve(sec);
    }, { threshold: 0.25 });
    obs.observe(sec);
  }

  // Ships-by countdown, Bangkok time
  var shipTimer;
  function initShipCountdown() {
    var box = document.querySelector('.shipping-calculate-date'); if (!box) return;
    clearInterval(shipTimer);
    var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 14;
    var th = box.getAttribute('data-locale') === 'th';
    var months = th ? ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'] : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    function bkk() { // current time in Asia/Bangkok as a Date-like object built from parts
      var s = new Date().toLocaleString('en-US', { timeZone: 'Asia/Bangkok', hour12: false });
      return new Date(s);
    }
    function fmt(d) { return th ? d.getDate() + ' ' + months[d.getMonth()] : months[d.getMonth()] + ' ' + d.getDate(); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = bkk();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0);
      var d0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var d1 = new Date(d0.getTime() + 86400000);
      document.querySelectorAll('.pdp-date-0').forEach(function (el) { el.textContent = fmt(d0); });
      document.querySelectorAll('.pdp-date-1').forEach(function (el) { el.textContent = fmt(d1); });
      // 24 Oct 2026 (Luka): after the cutoff, count down to midnight ("ships tomorrow if you order
      // within ..."); at midnight it switches to counting down to today's cutoff. More urgency at night.
      var target = now < today ? today : d1;
      var dist = target - now;
      var h = Math.floor(dist / 3600000), m = Math.floor((dist % 3600000) / 60000), sec = Math.floor((dist % 60000) / 1000);
      var txt = th ? h + ' ชม. ' + m + ' นาที ' + sec + ' วินาที' : h + 'hr ' + pad(m) + 'min ' + pad(sec) + 'sec';
      var todayEl = box.querySelector('.shipping__message--today'), tomEl = box.querySelector('.shipping__message--tomorrow');
      if (now < today) { todayEl.style.display = 'block'; tomEl.style.display = 'none'; box.querySelectorAll('.remain-time').forEach(function (e) { e.textContent = txt; }); }
      else { todayEl.style.display = 'none'; tomEl.style.display = 'block'; box.querySelectorAll('.within-time').forEach(function (e) { e.textContent = txt; }); }
    }
    tick(); shipTimer = setInterval(tick, 1000);
  }

  // Night-by-night timeline: progress line fills and boxes reveal as you scroll
  function initTimeline() {
    var mid = document.querySelector('.timeline__mid'); if (!mid) return;
    var steps = Array.prototype.slice.call(mid.querySelectorAll('.timeline__row_center_step'));
    var boxes = Array.prototype.slice.call(mid.querySelectorAll('.timeline__row_content_box'));
    var entry = mid.querySelector('.timeline__mid_row'); if (!entry || !steps.length) return;
    var total = 0, dists = [], ticking = false;
    function center(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    function dist(a, b) { var c1 = center(a), c2 = center(b); return Math.sqrt(Math.pow(c2.x - c1.x, 2) + Math.pow(c2.y - c1.y, 2)); }
    function measure() {
      total = dist(steps[0], steps[steps.length - 1]);
      entry.style.setProperty('--timeline-height', total + 'px');
      dists = steps.map(function (s) { return dist(steps[0], s); });
    }
    function update() {
      ticking = false;
      var r = mid.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var from = r.top - window.innerHeight * 0.85, h, all;
      if (from > 0) { h = 0; all = false; }
      else if (from <= -r.height) { h = total; all = true; }
      else { h = Math.min(Math.abs(from) / r.height, 1) * total; all = null; }
      entry.style.setProperty('--timeline-height-dynamic', h + 'px');
      steps.forEach(function (s, i) {
        var v = all !== null ? all : h >= dists[i];
        s.classList.toggle('viewing', v);
        if (boxes[i]) boxes[i].classList.toggle('viewing', v);
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.removeEventListener('scroll', window.__pdpTl || function () {});
    window.__pdpTl = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); update(); }, 250); });
    measure(); update();
    setTimeout(function () { measure(); update(); }, 800); // after fonts/images settle
  }

  // Rating popup: hover on desktop, tap on mobile
  function initRatingPopup() {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    $(document).off('.pdprate'); $('.rated_text').off('.pdprate');
    if (mobile) {
      $(document).on('click.pdprate', function (e) { if (!$(e.target).closest('.rated_text, .pop-rating_box').length) $('.pop-rating_box').hide(); });
      $('.rated_text').on('click.pdprate', function (e) { if ($(e.target).closest('.pop-rating_box').length) return; $('.pop-rating_box').toggle(); });
    } else {
      $('.rated_text').on('mouseenter.pdprate', function () { $('.pop-rating_box').show(); }).on('mouseleave.pdprate', function () { $('.pop-rating_box').hide(); });
      $('.pop-rating_box').hide();
    }
  }

  function initHeader() {
    // theme header is used now; no fixed-nav handling
  }

  function initAll() {
    initHero(); initSteps(); initShop(); initTabs(); initBundles(); initAtc(); initAccordions(); initTemperatureBars(); initShipCountdown(); initHeader(); initTimeline(); initRatingPopup();
  }

  $(initAll);
  // Theme editor: re-init when a section is reloaded
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 50); });
})(jQuery);
